import React, { memo } from 'react';

// ============================================
// Types
// ============================================

interface LogoProps {
  className?: string;
  size?: number;
  variant?: 'gradient' | 'white' | 'dark';
}

// ============================================
// Component
// ============================================

export const Logo: React.FC<LogoProps> = memo(({ 
  className = '', 
  size = 40, 
  variant = 'gradient' 
}) => {
  return (
    <div 
      className={`flex items-center justify-center ${className}`} 
      style={{ width: size, height: size }}
    >
      <img 
        src="/icon.png" 
        alt="OB Workflow Logo"
        className="w-full h-full object-contain hover:scale-105 transition-transform duration-300 pointer-events-none"
        loading="eager"
      />
    </div>
  );
});

Logo.displayName = 'Logo';

export default Logo;
